import { DefaultContainer } from '@/shared/ui';
import { MetaDecorator } from '@/shared/utils';
import { privacyHTML } from './privacyHTML';

const PrivacyPage = () => (
  <>
    <MetaDecorator
      description='meta.privacyPolicy.description'
      title='meta.privacyPolicy.title'
    />
    <DefaultContainer
      dangerouslySetInnerHTML={{
        __html: privacyHTML,
      }}
    />
  </>
);

export default PrivacyPage;
